import React, { ReactNode, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import ChatBox from "../ChatBox";
import QuizResumer from "../QuizResumer";
import AnnouncementBanner from "../AnnouncementBanner";
import LiveStreamBanner from "../LiveStreamBanner";
import { FaHome, FaChalkboardTeacher, FaFolderOpen, FaImages, FaComments, FaUsers, FaUser } from "react-icons/fa";

interface SidebarLayoutProps {
    children: ReactNode;
    noPadding?: boolean;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children, noPadding = false }) => {
    // Combined state to track layout mode
    // Desktop Layout active if Width >= 1024px (tablet landscape and up)
    const [isDesktopMode, setIsDesktopMode] = useState<boolean>(() => {
        if (typeof window !== "undefined") {
            return window.innerWidth >= 1024;
        }
        return false;
    });

    const location = useLocation();
    const isHomePage = location.pathname === '/';

    useEffect(() => {
        const checkLayout = () => {
            const width = window.innerWidth;
            setIsDesktopMode(width >= 1024);
        };

        // Check initially
        checkLayout();

        // Listen for resize
        window.addEventListener('resize', checkLayout);
        return () => window.removeEventListener('resize', checkLayout);
    }, []);

    return (
        <div className="h-full bg-gray-50 dark:bg-gray-900 font-sans">
            {!isDesktopMode ? (
                /* Mobile/Tablet Layout */
                <div className="h-full w-full bg-gray-50 dark:bg-gray-900 overflow-y-auto custom-scrollbar relative">
                    <div className="min-h-full flex flex-col">
                        <Header />
                        <main className="flex-1 pt-16 w-full flex flex-col relative z-0">
                            {/* Hiện Banner ở mọi trang - Mobile Fix */}
                            {/* Ưu tiên hiển thị Live Stream trước */}
                            <LiveStreamBanner />
                            <AnnouncementBanner />
                            <div className="flex-1 pb-4">
                                {children}
                            </div>
                        </main>
                        <Footer />
                    </div>
                </div>
            ) : (
                /* Desktop Layout */
                <div className="flex h-full overflow-hidden">
                    <Sidebar />
                    <main className="flex-1 flex flex-col min-w-0 h-full overflow-hidden bg-gray-50 dark:bg-gray-900">
                        {/* Hiện Banner ở mọi trang */}
                        <LiveStreamBanner />
                        <AnnouncementBanner />
                        <div className={`flex-1 overflow-y-auto ${noPadding ? '' : 'p-8'} custom-scrollbar`}>
                            {children}
                        </div>
                    </main>
                </div>
            )}

            {/* Global Components */}
            <ChatBox hideOnDesktop={true} />
            <QuizResumer />
        </div>
    );
};

export default SidebarLayout;
